var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "mount-options" },
    [
      _c("tab-heading", _vm._g({}, _vm.$listeners), [
        _c("h2", { staticClass: "text-center" }, [_vm._v("Mount Options")]),
        _c("p", { staticClass: "lead text-center mb-1" }, [
          _vm._v("Choose a single or double mount for your frame:"),
        ]),
        _c("p", { staticClass: "text-center font-italic mb-0" }, [
          _vm._v(
            "Please note that if you have selected a mount, glazing is required for delivery."
          ),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "text-center my-4" },
        [
          _c(
            "b-form-radio-group",
            {
              staticClass: "mount-type-radio",
              attrs: { size: "lg", buttons: "", "button-variant": "brand" },
              model: {
                value: _vm.selectedMount.type,
                callback: function ($$v) {
                  _vm.$set(_vm.selectedMount, "type", $$v)
                },
                expression: "selectedMount.type",
              },
            },
            [
              _c(
                "b-form-radio",
                { attrs: { value: "single" } },
                [
                  _vm._v("Single Mount"),
                  _c("b-overlay", { attrs: { show: _vm.loading } }, [
                    _c("small", [_vm._v("£" + _vm._s(_vm.singleMountPrice))]),
                  ]),
                ],
                1
              ),
              _c(
                "b-form-radio",
                { attrs: { value: "double" } },
                [
                  _vm._v("Double Mount"),
                  _c("b-overlay", { attrs: { show: _vm.loading } }, [
                    _c("small", [_vm._v("£" + _vm._s(_vm.doubleMountPrice))]),
                  ]),
                ],
                1
              ),
              _c(
                "b-form-radio",
                { attrs: { value: "none" } },
                [
                  _vm._v("None"),
                  _c("b-overlay", { attrs: { show: _vm.loading } }, [
                    _c("small", [_vm._v("£0.00")]),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-alert",
        {
          attrs: {
            show: _vm.validation.warnings.length > 0,
            variant: "warning",
          },
        },
        _vm._l(_vm.validation.warnings, function (warning, idx) {
          return _c("p", { key: idx, staticClass: "mb-0" }, [
            _vm._v(_vm._s(warning)),
          ])
        }),
        0
      ),
      _c(
        "b-alert",
        {
          attrs: {
            show: !_vm.validation.isValid && _vm.selectedMount.type != "none",
            variant: "danger",
          },
        },
        _vm._l(_vm.validation.problems, function (problem, idx) {
          return _c("p", { key: idx, staticClass: "mb-0" }, [
            _vm._v(_vm._s(problem)),
          ])
        }),
        0
      ),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { staticClass: "mb-3 mb-md-0", attrs: { md: "6" } },
            [
              _c(
                "b-overlay",
                {
                  attrs: {
                    rounded: "",
                    show: _vm.selectedMount.type == "none",
                  },
                  on: { click: _vm.onSingleMountClick },
                  scopedSlots: _vm._u([
                    {
                      key: "overlay",
                      fn: function () {
                        return [_vm._v(" ")]
                      },
                      proxy: true,
                    },
                  ]),
                },
                [
                  _c("h4", [_vm._v("Top Mount")]),
                  !_vm.loadingMountboards
                    ? _c("mountboard-colours", {
                        attrs: { mountboards: _vm.mountboards },
                        model: {
                          value: _vm.selectedMount.top,
                          callback: function ($$v) {
                            _vm.$set(_vm.selectedMount, "top", $$v)
                          },
                          expression: "selectedMount.top",
                        },
                      })
                    : _vm._e(),
                  _c(
                    "b-collapse",
                    { attrs: { id: "equal-width-collapse", visible: "" } },
                    [
                      _c(
                        "b-row",
                        { attrs: { "align-h": "center" } },
                        [
                          _c(
                            "b-col",
                            { attrs: { sm: "6" } },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: "Mount Width:",
                                    state: _vm.isEqualBorderValid,
                                    "invalid-feedback": `${_vm.minBorderWidth}mm is the minimum border width.`,
                                  },
                                },
                                [
                                  _c(
                                    "b-input-group",
                                    { attrs: { append: "mm" } },
                                    [
                                      _c("b-form-input", {
                                        attrs: {
                                          size: "lg",
                                          number: "",
                                          min: "10",
                                          step: "1",
                                          state: _vm.isEqualBorderValid,
                                        },
                                        model: {
                                          value: _vm.equalBorderWidth,
                                          callback: function ($$v) {
                                            _vm.equalBorderWidth = _vm._n($$v)
                                          },
                                          expression: "equalBorderWidth",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "text-center" },
                    [
                      _c(
                        "b-button",
                        {
                          directives: [
                            {
                              name: "b-toggle",
                              rawName:
                                "v-b-toggle.equal-width-collapse.custom-width-collapse",
                              modifiers: {
                                "equal-width-collapse": true,
                                "custom-width-collapse": true,
                              },
                            },
                          ],
                          attrs: { variant: "primary", size: "sm" },
                          on: {
                            click: function ($event) {
                              _vm.isCustomWidths = !_vm.isCustomWidths
                            },
                          },
                        },
                        [
                          _c("span", { staticClass: "material-icons" }, [
                            _vm._v("edit"),
                          ]),
                          _vm._v(
                            " " +
                              _vm._s(
                                !_vm.isCustomWidths
                                  ? "Set each border width individually"
                                  : "Set single width for all borders"
                              )
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-collapse",
                    {
                      staticClass: "mt-3",
                      attrs: { id: "custom-width-collapse" },
                    },
                    [
                      _c("mount-width-selector", {
                        model: {
                          value: _vm.selectedMount.borders,
                          callback: function ($$v) {
                            _vm.$set(_vm.selectedMount, "borders", $$v)
                          },
                          expression: "selectedMount.borders",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "b-col",
            { attrs: { md: "6" } },
            [
              _c(
                "b-overlay",
                {
                  attrs: {
                    rounded: "",
                    show: _vm.selectedMount.type != "double",
                  },
                  on: { click: _vm.onDoubleMountClick },
                  scopedSlots: _vm._u([
                    {
                      key: "overlay",
                      fn: function () {
                        return [_vm._v(" ")]
                      },
                      proxy: true,
                    },
                  ]),
                },
                [
                  _c("h4", [_vm._v("Bottom Mount")]),
                  !_vm.loadingMountboards
                    ? _c("mountboard-colours", {
                        attrs: { mountboards: _vm.mountboards },
                        model: {
                          value: _vm.selectedMount.bottom,
                          callback: function ($$v) {
                            _vm.$set(_vm.selectedMount, "bottom", $$v)
                          },
                          expression: "selectedMount.bottom",
                        },
                      })
                    : _vm._e(),
                  _c(
                    "b-row",
                    { attrs: { "align-h": "center" } },
                    [
                      _c(
                        "b-col",
                        { attrs: { sm: "6" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: "Reveal Size:",
                                state: _vm.isRevealSizeValid,
                                "invalid-feedback": `Minimum: ${_vm.minReveal}mm`,
                              },
                            },
                            [
                              _c(
                                "b-input-group",
                                { attrs: { append: "mm" } },
                                [
                                  _c("b-form-input", {
                                    attrs: {
                                      size: "lg",
                                      number: "",
                                      state: _vm.isRevealSizeValid,
                                    },
                                    model: {
                                      value: _vm.selectedMount.reveal,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.selectedMount,
                                          "reveal",
                                          $$v
                                        )
                                      },
                                      expression: "selectedMount.reveal",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._m(0),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("p", { staticClass: "mt-5" }, [
      _vm._v(
        "If you require a multi-aperture mount within your custom picture frame please contact us to discuss your requirements and we can place the order manually. Call us on "
      ),
      _c("a", { attrs: { href: "tel:01246554338" } }, [_vm._v("01246 554338")]),
      _vm._v(" or send us an email to "),
      _c("a", { attrs: { href: "mailto:sales@bramptonframing.com" } }, [
        _vm._v("sales@bramptonframing.com"),
      ]),
      _vm._v("."),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }